// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapped-not-selling-product .modal-heading-main {
  color: #333333;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  padding-block: 15px;
}
.mapped-not-selling-product .modal-header {
  justify-content: center;
}
.mapped-not-selling-product .modal-close-btn {
  right: 14px;
  top: 26px;
  width: 20px;
  height: 20px;
}
.mapped-not-selling-product .modal-main {
  max-width: 480px;
  padding: 0px;
  padding-top: 10px;
}
.mapped-not-selling-product .product-name-price-wrap {
  padding: 20px;
}
.mapped-not-selling-product .product-name-value {
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: #000;
  padding-top: 7px;
  font-family: var(--font-family);
}
.mapped-not-selling-product input::-webkit-inner-spin-button {
  display: none;
}
.mapped-not-selling-product .product-name-title {
  color: var(--primary-color);
  font-size: 16px;
  line-height: 20px;
}
.mapped-not-selling-product .product-name-wrap {
  min-height: 60px;
  margin-bottom: 20px;
}
.mapped-not-selling-product .product-price-title {
  color: var(--primary-color);
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 10px;
}
.mapped-not-selling-product .submit-btn-wrap {
  background: #6ECB44;
  max-width: 160px;
  border-radius: 11px;
  margin: 30px auto;
}
.mapped-not-selling-product .submit-btn-wrap button {
  color: #FFFFFF;
  padding-block: 15px;
  text-align: center;
  width: 100%;
  border-radius: 4px;
  border-bottom-left-radius: 11px;
  border-bottom-right-radius: 11px;
}

.modal-wrap.mapped-not-selling-product {
  display: flex;
}
.modal-wrap.mapped-not-selling-product .modal-main {
  max-height: 90vh;
  top: auto;
  bottom: auto;
  overflow: hidden;
  overflow-y: auto;
}
.modal-wrap.mapped-not-selling-product .effective-date-wrap {
  padding-inline: 20px;
}
.modal-wrap.mapped-not-selling-product .effective-date-wrap mat-icon.date-clear-btn {
  opacity: 0.7;
  cursor: pointer;
  display: inline-block;
}
.modal-wrap.mapped-not-selling-product .effective-date-wrap .suggested-effective-date-wrap {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  padding-bottom: 10px;
  display: flex;
  gap: 10px;
  padding-top: 10px;
}
.modal-wrap.mapped-not-selling-product .effective-date-wrap .suggested-effective-date-label {
  font-weight: 500;
}
.modal-wrap.mapped-not-selling-product .effective-date-wrap .effective-date-value {
  margin-block: 10px;
}

@media screen and (max-width: 767px) {
  .mapped-not-selling-product .modal-main {
    max-width: 360px;
    padding: 0px;
    padding-top: 10px;
  }
  .mapped-not-selling-product .modal-heading-main {
    font-size: 16px;
    line-height: 20px;
  }
  .mapped-not-selling-product .modal-close-btn {
    right: 14px;
    top: 25px;
    width: 18px;
    height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/mapped-notselling-product/mapped-notselling-product.component.scss"],"names":[],"mappings":"AAEI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AADR;AAGI;EACI,uBAAA;AADR;AAGI;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AADR;AAGI;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;AADR;AAGI;EACI,aAAA;AADR;AAGI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;AADR;AAGI;EACI,aAAA;AADR;AAGI;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;AADR;AAGI;EACI,gBAAA;EACA,mBAAA;AADR;AAGI;EACI,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAGI;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AADR;AAEQ;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,gCAAA;AAAZ;;AAKA;EACI,aAAA;AAFJ;AAGI;EACI,gBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAII;EAOI,oBAAA;AARR;AAGQ;EACI,YAAA;EACA,eAAA;EACA,qBAAA;AADZ;AAIQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AAFZ;AAIQ;EACI,gBAAA;AAFZ;AAIQ;EACI,kBAAA;AAFZ;;AAOA;EAGQ;IACI,gBAAA;IACA,YAAA;IACA,iBAAA;EANV;EAQM;IACI,eAAA;IACA,iBAAA;EANV;EAQM;IACI,WAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;EANV;AACF","sourcesContent":[".mapped-not-selling-product\n{\n    .modal-heading-main {\n        color: #333333;\n        font-weight: 600;\n        font-size: 18px;\n        line-height: 20px;\n        text-align: center;\n        padding-block: 15px;\n    }\n    .modal-header{\n        justify-content: center;\n    }\n    .modal-close-btn{\n        right: 14px;\n        top: 26px;\n        width: 20px;\n        height: 20px;\n    }\n    .modal-main{\n        max-width: 480px;\n        padding: 0px;\n        padding-top: 10px;\n    }\n    .product-name-price-wrap {\n        padding: 20px;\n    }\n    .product-name-value {\n        font-size: 14px;\n        line-height: 18px;\n        font-weight: 400;\n        color: #000;\n        padding-top: 7px;\n        font-family:  var(--font-family);\n    }\n    input::-webkit-inner-spin-button{\n        display: none;\n    }\n    .product-name-title {\n        color:var(--primary-color);\n        font-size: 16px;\n        line-height: 20px;\n    }\n    .product-name-wrap {\n        min-height: 60px;\n        margin-bottom: 20px;\n    }\n    .product-price-title {\n        color: var(--primary-color);\n        font-size: 16px;\n        line-height: 20px;\n        margin-bottom: 10px;\n    }\n    .submit-btn-wrap {\n        background: #6ECB44;\n        max-width: 160px;\n        border-radius: 11px;\n        margin: 30px auto;\n        button { \n            color: #FFFFFF;\n            padding-block: 15px;\n            text-align: center;\n            width: 100%;\n            border-radius: 4px;\n            border-bottom-left-radius: 11px;\n            border-bottom-right-radius: 11px;\n        }\n\n    }\n}\n.modal-wrap.mapped-not-selling-product{\n    display: flex;\n    .modal-main{\n        max-height: 90vh;\n        top: auto;\n        bottom: auto;\n        overflow: hidden;\n        overflow-y: auto;\n    }\n\n    .effective-date-wrap{\n     \n        mat-icon.date-clear-btn {\n            opacity: 0.7;\n            cursor: pointer;\n            display: inline-block;\n        }\n        padding-inline: 20px;\n        .suggested-effective-date-wrap {\n            font-family:  var(--font-family);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 17px;\n            padding-bottom: 10px;\n            display: flex;\n            gap: 10px;\n            padding-top: 10px;\n        }\n        .suggested-effective-date-label {\n            font-weight: 500;\n        }\n        .effective-date-value {\n            margin-block: 10px;\n        }\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .mapped-not-selling-product\n    {\n        .modal-main{\n            max-width: 360px;\n            padding: 0px;\n            padding-top: 10px;\n        } \n        .modal-heading-main{\n            font-size: 16px;\n            line-height: 20px;\n        }   \n        .modal-close-btn{\n            right: 14px;\n            top: 25px;\n            width: 18px;\n            height: 18px;\n        }\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
